import jQuery from 'jquery';
import 'metismenu';

function SideNavigation() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            // Call the metsiMenu plugin and plug it to sidebar navigation
            jQuery(element).metisMenu();
        }
    };
};

export {SideNavigation};



// WEBPACK FOOTER //
// ./app/components/common/navbar/navigation.directive.js